import { baseQuery, baseQueryWithReAuth } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const countryService = createApi({
  reducerPath: "countryService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getCountries: builder.query<any, void>({
      query: () => ({
        url: `/countries`,
        method: "GET",
      }),
    }),
    getCurrencies: builder.query<any, void>({
      query: () => ({
        url: `/currencies`,
      }),
      transformResponse: (rawData: any) => {
        if (rawData?.success) {
          return rawData.data.sort((a: any, b: any) => a?.code?.localeCompare(b?.code));
        }
      },
    }),
    getDisbursements: builder.query<any, void>({
      query: () => ({
        url: `/disbursements`,
      }),
      transformResponse: (rawData: any) => {
        if (rawData?.success) {
          return rawData.data;
        }
      },
    }),
    getTurnoverRanges: builder.query<any, void>({
      query: () => ({
        url: `/info/turnover-ranges`,
      }),
      transformResponse: (rawData: any) => {
        if (rawData?.success) {
          return rawData.data;
        }
      },
    }),
    getAverageTicketSize: builder.query<any, void>({
      query: () => ({
        url: `/info/average-ticket-size`,
      }),
      transformResponse: (rawData: any) => {
        if (rawData?.success) {
          return rawData.data;
        }
      },
    }),
  }),
});

export const {
  useGetCountriesQuery,
  useGetCurrenciesQuery,
  useGetDisbursementsQuery,
  useGetTurnoverRangesQuery,
  useGetAverageTicketSizeQuery,
} = countryService;
